require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-five-things-you-know-if-you-are-an-account-manager.json") })
        }
      }, "path---news-five-things-you-know-if-you-are-an-account-manager");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-five-things-you-know-if-you-are-an-account-manager!./.cache/json/news-five-things-you-know-if-you-are-an-account-manager.json
// module id = 1421
// module chunks = 231608221292675